<template>
    <div class="customer-groups">
        <div class="m-5">
            <a-table
                class="customer-groups-table"
                :key="'vtable-' + renderCount"
                :rowKey="`_id`"
                :columns="columns"
                :dataSource="getItems()"
                :pagination="pagination"
                @change="handleTableChange"
                :customRow="
                    (record) => {
                        return {
                            props: {},
                            on: {
                                mouseover: (event) => {
                                    rowMouseOver(record);
                                },
                                mouseleave: (event) => {
                                    rowMouseLeave(record);
                                },
                                click: (event) => {
                                    rowClicked(record);
                                },
                            },
                        };
                    }
                "
            >
                <span slot="indexTitle"> # </span>
                <span slot="nameTitle"> {{ $t("wp.name") }} </span>
                <span slot="descriptionTitle">{{ $t("wp.description") }}</span>
                <span slot="contactsTitle">{{ $t("wp.contacts") }}</span>

                <template slot="avatar" slot-scope="text, record">
                    <div
                        class="customer-group-avatar text-center"
                        :class="{ 'customer-group-avatar-odd': record.index % 2 === 0 }"
                    >
                        <md-highlight-text md-term="term" class="text-center">
                            {{ record.name.slice(0, 2).toUpperCase() }}
                        </md-highlight-text>
                    </div>
                </template>

                <span slot="contacts" slot-scope="text, record">
                    {{
                        $_.get(record, "contacts.length", 0)
                            ? `${$_.get(record, "contacts.length", 0)} User`
                            : $t("wp.noContactFound")
                    }}</span
                >
                <span slot="description" slot-scope="text, record">{{ $_.get(record, "description", "-") }}</span>
                <span
                    slot-scope="text, record"
                    class="d-flex flex-row justify-content-end operation-buttons"
                    :class="{ hidden: selectedRowId !== record._id }"
                    slot="operation"
                >
                    <span class="material-icons mx-2 text-primary operation-button" @click="(e) => onEdit(e, record)">
                        edit
                    </span>
                    <span
                        @click="(e) => showConfirm(e, record)"
                        class="material-icons mx-2 text-danger operation-button"
                    >
                        delete
                    </span>
                </span>
            </a-table>
        </div>
    </div>
</template>

<script>
import WHATSAPP_API from "../../../../api/whatsapp";
import log2 from "../../../../utils/log2";
import { message } from "ant-design-vue";

const columns = [
    {
        dataIndex: "index",
        key: "index",
        slots: { title: "indexTitle" },
    },
    {
        dataIndex: "avatar",
        key: "avatar",
        slots: { title: "" },
        scopedSlots: { customRender: "avatar" },
        width: "5%",
    },

    {
        dataIndex: "name",
        key: "name",
        slots: { title: "nameTitle" },
        scopedSlots: { customRender: "name" },
    },
    {
        dataIndex: "description",
        key: "description",
        slots: { title: "descriptionTitle" },
        scopedSlots: { customRender: "description" },
    },
    {
        dataIndex: "contacts",
        key: "contacts",
        slots: { title: "contactsTitle" },
        scopedSlots: { customRender: "contacts" },
    },
    {
        title: "",
        dataIndex: "operation",
        key: "operation",
        slots: { title: "operationTitle" },
        scopedSlots: { customRender: "operation" },
    },
];
const log = log2("CustomerGroupsTable");
export default {
    name: "CustomerGroupsTable",
    props: {
        onRowSelected: {
            type: Function,
        },
        onRowDeleted: {
            type: Function,
        },
        groups: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => ({
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                current: 1
            }),
        },
        onTableChange: {
            type: Function,
        },
    },
    components: {},
    data() {
        return {
            columns,
            loading: false,
            renderCount: 0,
            selectedRowId: null,
        };
    },
    methods: {
        getItems() {
            return this.groups.map((x, i) => ({
                ...x,
                index: i,
            }));
        },
        rowMouseOver(record) {
            this.selectedRowId = record._id;
        },
        rowMouseLeave(record) {
            this.selectedRowId = null;
        },
        rowClicked(record) {
            this.onRowSelected(record);
        },
        onEdit(e, item) {
            e.preventDefault();
            e.stopPropagation();
            this.rowClicked(item);
        },
        deleteCustomerGroup(id) {
            const hide = message.loading(this.$t("wp.customerGroupDeleting"), 0);
            WHATSAPP_API.BROADCAST.deleteGroupById(id)
                .then((res) => {
                    message.success(this.$t("wp.customerGroupDeletingSuccess"));
                    if (this.onRowDeleted) this.onRowDeleted(id);
                })
                .catch((err) => {
                    message.error(this.$t("wp.customerGroupDeletingError"));
                })
                .finally(() => {
                    hide();
                });
        },
        showConfirm(e, record) {
            e.preventDefault();
            e.stopPropagation();
            this.$confirm({
                title: this.$t("wp.deleteCustomerGroup", { name: `(${record.name})` }),
                onOk: () => {
                    this.deleteCustomerGroup(record._id);
                },
                onCancel() {
                },
            });
        },
        handleTableChange(pagination) {
            if (this.onTableChange) {
                this.onTableChange(pagination);
            }
        },
    }
};
</script>

<style lang="scss">
.customer-groups {
    overflow: auto;
    //overflow-x: auto;
    //overflow-y: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;

    .ant-table table {
        width: 100% !important;
        text-align: left !important;
        border-radius: 4px 4px 0 0 !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        overflow-wrap: break-word !important;
    }

    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        border-bottom: 1px solid #e8e8e8 !important;
        -webkit-transition: background 0.3s !important;
        transition: background 0.3s !important;
    }

    .ant-table-row-cell-break-word {
        word-wrap: break-word !important;
        word-break: break-word !important;
    }

    .ant-table {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        clear: both !important;
    }

    .ant-card {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        background: #fff !important;
        border-radius: 2px !important;
        -webkit-transition: all 0.3s !important;
        transition: all 0.3s !important;
    }

    .ant-table-body {
        ant-table-thead {
            margin-bottom: 10px !important;
        }

        tr {
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
            cursor: pointer;
        }

        td {
            font-family: Poppins !important;
            font-size: 12px !important;
            font-weight: 400 !important;
            color: #181c32 !important;
            border-bottom: none !important;
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
        }

        th {
            border-right: unset !important;
            border-bottom: 1px solid #e8e8e8 !important;
            padding: 0px 16px !important;
            overflow-wrap: break-word;

            &:last-child {
                border-right: unset !important;
            }
        }
    }

    .ant-table-body tbody td {
        border-right: unset !important;
        padding: 16px 16px !important;

        &:last-child {
            border-right: unset !important;
        }
    }

    .ant-table-thead > tr > th {
        background: #ffffff;
    }

    .operation-buttons {
        max-width: 0px;
        cursor: pointer;

        &.hidden {
            .operation-button {
                display: none;
            }
        }
    }

    .customer-group-avatar {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #6899c1;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }

    .customer-group-avatar-odd {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #c980a3;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }
}
</style>
